import { Pipe, PipeTransform } from '@angular/core';
import { resolveAsset } from '@app-shared/services/asset-resolver/asset-resolver.service';
import { getClientConfig } from '@config/client-config';

@Pipe({
  name: 'assetUrl',
})
export class AssetUrlPipe implements PipeTransform {
  private env = getClientConfig().environments;
  transform(path: string): string {
    if (this.env.isGeotabEnv) {
      const pathStartsWithSlash = path.startsWith('/');
      return pathStartsWithSlash ? `${this.env.geotabDeployUrl}${path}` : `${this.env.geotabDeployUrl}/${path}`;
    }
    return path;
  }
}

@Pipe({
  name: 'assetURL',
})
export class AssetURLPipe implements PipeTransform {
  constructor() {}

  transform(path: string): string {
    return resolveAsset(path);
  }
}
